import React from 'react';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import { Switch } from 'react-router-dom';
import { AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { Quest } from 'cccisd-laravel-assignment';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome';
import TimeTracker from './pages/TimeTracker';
import Apps from './pages/Apps';
import Messaging from './pages/Messaging';
import Email from './pages/Email';
import ReleaseNotes from './pages/ReleaseNotes';
import Tickets from './pages/Tickets';
import Packages from './pages/Packages';
import Usages from './pages/Usages';
import PMDashboard from './pages/PMDashboard';
import ClientSupportDashboard from './pages/ClientSupportDashboard';
import Passwords from './pages/Passwords';
import DevOps from './pages/DevOps';

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';
import ClientSupportPlayer from './pages/ClientSupportDashboard/ClientSupportPlayer';

// Bind MainLayout by default
const AppRoute = p => <Route layout={MainLayout} {...p} />;

const MainLayoutFluid = p => <MainLayout className="container-fluid" {...p} />;
const MainLayoutSecondaryNav = p => <MainLayout showSecondaryNav {...p} />;
const MainLayoutFluidSecondaryNav = p => <MainLayout className="container-fluid" showSecondaryNav {...p} />;

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;
const seePMDashboard = Fortress.hasAnyAccess('quest.view_identifiable_data', 224);

if (!seePMDashboard) {
    AppDefinitions.routes = AppDefinitions.routes.filter(route => route.handle !== 'pm_dashboard');
}

const componentMatch = {
    AppdefManage,
    Welcome,
    TimeTracker,
    Apps,
    Messaging,
    Email,
    ReleaseNotes,
    Tickets,
    Packages,
    Usages,
    PMDashboard,
    ClientSupportDashboard,
    Passwords,
    DevOps,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    MainLayoutSecondaryNav,
    MainLayoutFluidSecondaryNav,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = componentMatch[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={
                        'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayoutFluid
                    }
                />
            );
        })}
        <AppRoute path="/" component={Welcome} exact />
        <AppRoute path="/welcome" component={Welcome} layout={MainLayoutFluidSecondaryNav} />

        <AppRoute path={['/quest/preview', '/d', '/survey']} component={Quest} layout={QuestLayout} />

        <AppRoute
            path="/clientSupportSurvey"
            component={ClientSupportPlayer}
            componentProps={{
                errorLayout: MainLayoutFluid,
            }}
            layout={MainLayoutFluid}
        />

        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}

        <AppRoute
            path="/account"
            layout={null}
            component={Nexus}
            componentProps={{ defaultLayout: MainLayout, registrationSurveyLayout: QuestLayout }}
        />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={NotFound} />
    </Switch>
);
